// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import InternalButton from '../button/internal';
import { useInternalI18n } from '../i18n/context';
import { fireNonCancelableEvent } from '../internal/events';
export function ClearSortButton({ multiColumnSort, i18nStrings, onClearSort }) {
    var _a;
    const i18n = useInternalI18n('table');
    return (React.createElement(InternalButton, { variant: "inline-link", formAction: "none", onClick: () => {
            fireNonCancelableEvent(multiColumnSort.onChange, { sortingColumns: [] });
            onClearSort === null || onClearSort === void 0 ? void 0 : onClearSort();
        } }, (_a = i18n('i18nStrings.clearSort', i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.clearSort)) !== null && _a !== void 0 ? _a : ''));
}
//# sourceMappingURL=clear-sort.js.map